module.exports = __webpack_public_path__ + "static/media/Operator-Booking.eed15ebd.png";